import React from 'react';
import { MdArrowBack, MdReceipt, MdTrendingUp } from 'react-icons/md';

const DirectDepositDetailScreen = ({ onNavigate, onBack }) => {
  const depositData = {
    sender: "GOOGLE CANADA CORP",
    amount: "$3,450.00",
    date: "Jan 15, 2026",
    time: "3:45 AM",
    account: "VALUE PLUS (....5252)",
    type: "Payroll / Salary",
    status: "Funds Available",
    reference: "ID: 99283471029384",
    nextExpected: "Jan 30, 2026"
  };

  return (
    <div className="screen deposit-detail-screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('accounts'))} aria-label="Back to accounts">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Deposit Details</h1>
        </div>
        <MdReceipt size={22} style={{ color: 'var(--bh-black)' }} />
      </header>

      <div className="scroll-content gray-bg">
        <div className="deposit-hero-section">
          <div className="deposit-status-pill">{depositData.status}</div>
          <h1 className="positive-green">{depositData.amount}</h1>
          <p className="deposit-sender-name">{depositData.sender}</p>
          <p className="deposit-timestamp">{depositData.date} • {depositData.time}</p>
        </div>

        <div className="white-container detail-list-group">
          <div className="detail-row">
            <span>To Account</span>
            <strong>{depositData.account}</strong>
          </div>
          <div className="detail-row">
            <span>Transaction Type</span>
            <strong>{depositData.type}</strong>
          </div>
          <div className="detail-row">
            <span>Reference Number</span>
            <strong className="text-small">{depositData.reference}</strong>
          </div>
        </div>

        <div className="ancillary-info-card">
          <div className="aic-header">
            <MdTrendingUp className="positive-green" />
            <span>Deposit Insights</span>
          </div>
          <p>This is your <strong>12th</strong> consecutive deposit from this sender.</p>
          <div className="next-deposit-alert">
            <span>Next expected deposit:</span>
            <strong>{depositData.nextExpected}</strong>
          </div>
        </div>

        <div className="deposit-actions">
          <button className="secondary-action-btn">Download Receipt (PDF)</button>
          <button className="secondary-action-btn">Manage Deposit Notifications</button>
        </div>
      </div>
    </div>
  );
};

export default DirectDepositDetailScreen;
